module.exports = __webpack_public_path__ + "static/media/tum.e921b139.png";